import React from 'react';
import { EngineContext } from '../contexts/engine-context.js';
import { StatefulFragment } from './stateful-fragment.js';
function Application(props) {
    const content = props.children
        ? props.children
        : React.createElement(StatefulFragment, { fragment: props.fragment, instanceUUID: "root", uuid: "root" });
    return (React.createElement(EngineContext.Provider, { value: { engine: props.engine } }, content));
}
export { Application, };
//# sourceMappingURL=application.js.map